import { render, staticRenderFns } from "./EmplpymentDetail.vue?vue&type=template&id=4b40f6ec&scoped=true"
import script from "./EmplpymentDetail.vue?vue&type=script&lang=js"
export * from "./EmplpymentDetail.vue?vue&type=script&lang=js"
import style0 from "./EmplpymentDetail.vue?vue&type=style&index=0&id=4b40f6ec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b40f6ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b40f6ec')) {
      api.createRecord('4b40f6ec', component.options)
    } else {
      api.reload('4b40f6ec', component.options)
    }
    module.hot.accept("./EmplpymentDetail.vue?vue&type=template&id=4b40f6ec&scoped=true", function () {
      api.rerender('4b40f6ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmplpymentDetail.vue"
export default component.exports